export const REQUEST_POLICY = {
  CACHE_FIRST: 'cache-first',
  CACHE_ONLY: 'cache-only',
  NETWORK_ONLY: 'network-only',
  CACHE_AND_NETWORK: 'cache-and-network'
} as const
